import React, { useState } from "react";
import SolarSystemImg from "../../../Images/SolarCalculator/solarenergy-SystemSize.jpg";
import SolarPanelImg from "../../../Images/SolarCalculator/SolarProduction.png";
// import SolarPanelImg from "../../../Images/SolarCalculator/solar-panel.jpg";
import SolarProductionImg from "../../../Images/SolarCalculator/solarenergy-production.png";
import SiteSurvey from "./SiteSurvey";
import { Button, Modal } from "antd";

const JanicaRecommendation = ({ totalConsumption, recommendation }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  if (!recommendation) return null;
  return (
    <div className="mx-auto w-[80%]">
      {totalConsumption > 0 && (
        <div className="text-black">
          <h3>Total Monthly Consumption: {totalConsumption.toFixed(2)} kWh</h3>
        </div>
      )}
      <div className="bg-white p-5 flex flex-col gap-7 ">
        <h1 className="text-center text-2xl font-bold text-white w-fit mx-auto border rounded p-2 bg-error">
          Janica Recommendation
        </h1>

        <div className="flex flex-row justify-around">
          <div className="border flex flex-col  items-center w-[30%] rounded p-5">
            <h2 className="font-semibold">Recommended System Size</h2>
            <div className="text-center my-5 flex flex-col gap-2">
              <p className="text-3xl font-medium">
                {recommendation?.systemSizeKw} kW
              </p>
              <p className="text-mediumGray">
                * Ideal system size, finalized after a site survey.
              </p>
            </div>
            <img
              src={SolarProductionImg}
              className=" h-40 w-40 object-contain"
              alt="SolarProduction-Img "
            />
          </div>
          <div className="border flex flex-col  items-center w-[30%] gap-2 rounded p-5">
            <h2 className="font-semibold">Your Solar Production</h2>
            <div className="flex flex-col gap-1 text-center">
              <p className="text-base text-mediumGray">Number of Panels</p>
              <p className="text-3xl font-medium">
                {recommendation?.numberOfPanels}{" "}
                {`${recommendation?.numberOfPanels > 1 ? "panels" : "panel"}`}
              </p>
            </div>
            <div className="flex flex-col gap-1 text-center">
              <p className="text-base text-mediumGray">Monthly Production</p>
              <p className="text-3xl font-medium">
                {recommendation?.monthlyProduction} kWh
              </p>
            </div>

            <div className="flex flex-col gap-1 text-center">
              <p className="text-base text-mediumGray">Annual Production</p>
              <p className="text-3xl font-medium">
                {recommendation?.annualProduction} kWh
              </p>
            </div>
            <img
              src={SolarPanelImg}
              alt="SolarSystemSize-Img"
              className=" h-40 w-40 object-contain"
            />
          </div>
          <div className="border flex flex-col  items-center w-[30%] rounded p-5 gap-2">
            <h2 className="font-semibold">Your Estimate</h2>
            <div className="flex flex-col gap-1 text-center">
              <p className="text-base text-mediumGray">Estimated Cost</p>
              <p className="text-3xl font-medium">
                ₹{recommendation?.estimatedCost}
              </p>
              <p className="text-base text-green">
                ₹{recommendation?.afterSubsidy} after 30% subsidy
              </p>
            </div>

            <div className="flex flex-col gap-1 text-center">
              <p className="text-base text-mediumGray">
                Estimated Payback Period
              </p>
              <p className="text-3xl font-medium">
                {recommendation?.paybackYears} years
              </p>
            </div>
            <img
              src={SolarSystemImg}
              className=" h-40 w-40 object-contain"
              alt="SolarEstimate-Img"
            />
          </div>
        </div>
        <p className="ms-4">
          <span className="text-error">Note: </span>This calculation is an
          estimate for reference purposes. Actual figures may vary based on a
          site survey.
        </p>
        <button
          className="bg-error text-white rounded p-3 text-base font-semibold w-48 mx-auto hover:text-error hover:bg-white hover:border hover:border-bgBlack"
          onClick={showModal}
        >
          Book Your Site Survey
        </button>
        <SiteSurvey open={open} handleClose={handleClose} />
      </div>
    </div>
  );
};

export default JanicaRecommendation;
